import { IconSearch } from 'braid-design-system';
import { MockLocationSuggest } from 'wingman-fe';

import { ThemedExample } from '#src/components/ThemedExample/ThemedExample.tsx';

export const SeekLocationSuggest = () => (
  <ThemedExample>
    <MockLocationSuggest
      icon={<IconSearch />}
      id="seek-location-suggest"
      label="Location"
      schemeId="seekAnz"
      showStorybookAction
    />
  </ThemedExample>
);
